import { render, staticRenderFns } from "./donor-my-teams-sortby.vue?vue&type=template&id=751a3e30&"
import script from "./donor-my-teams-sortby.vue?vue&type=script&lang=js&"
export * from "./donor-my-teams-sortby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports